import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { LG_LOCALIZATION_SETTINGS } from "@logex/framework/lg-localization";
import {
    AppSettings,
    AuthorizationPermission,
    AuthorizationProfile
} from "@mrdm-self-service-frontend/shared/types";
import { Auth0AuthorizationService } from "@mrdm-self-service-frontend/shared/util-authorization";
import { tap, catchError, first, Observable, switchMap, of, firstValueFrom } from "rxjs";
import { SharedConfigService } from "./shared-config.service";
import { SharedLocalizationSettingsService } from "./shared-localization-settings.service";
import { SharedUserAuthorizationService } from "@mrdm-self-service-frontend/shared/data-access-authorization";

@Injectable({
    providedIn: "root"
})
export class SharedStartupService {
    private _httpClient = inject(HttpClient);
    private _configService = inject(SharedConfigService);
    private _auth = inject(Auth0AuthorizationService);
    private _authorizationService = inject(SharedUserAuthorizationService);
    private _localizationSettings = inject<SharedLocalizationSettingsService>(LG_LOCALIZATION_SETTINGS);


    initialize(): () => Promise<void> {
        return async () => {
            await firstValueFrom(this._loadConfig());
        };
    }

    private _loadConfig(): Observable<{
        user: AuthorizationProfile | null;
        permissions: AuthorizationPermission[];
    }> {
        return this._httpClient.get<AppSettings>("assets/config/appsettings.json").pipe(
            tap(c => this._configService._setConfigation(c)),
            switchMap(() => this._loadPermissions()),
            tap(() => this._localizationSettings.init())
        );
    }

    private _loadPermissions(): Observable<{
        user: AuthorizationProfile | null;
        permissions: AuthorizationPermission[];
    }> {
        return this._auth.isAuthenticated$.pipe(
            first(),
            switchMap(isAuthenticated =>
                isAuthenticated
                    ? this._authorizationService.loadUserData()
                    : of({ user: null, permissions: [] })
            ),
            catchError(() => of({ user: null, permissions: [] }))
        );
    }
}
